import { readLocalStorage } from '@/utils/local-storage/read-local-storage';
import { removeLocalStorageItem } from '@/utils/local-storage/safe-local-storage';
import { writeToLocalStorage } from '@/utils/local-storage/write-to-local-storage';

export type Favorite = string;

export const LEGACY_FAVORITES_STORAGE_KEY = 'favorites';
export const LEGACY_FAVORITES_RECONCILED_AT_KEY = 'favorites_reconciled_at';

export const getFavoritesStorageKey = (brandKey: string) =>
  `favorites.${brandKey}`;

export const getFavoritesReconciledAtKey = (brandKey: string) =>
  `favorites_reconciled_at.${brandKey}`;

export const FAVORITES_RECONCILE_THROTTLE_MS = 24 * 60 * 60 * 1000;

const uniqueFavorites = (ids: Favorite[]) => Array.from(new Set(ids));

export const writeFavorites = (brandKey: string, ids: Favorite[]) => {
  const unique = uniqueFavorites(ids);
  const storageKey = getFavoritesStorageKey(brandKey);
  if (unique.length === 0) {
    removeLocalStorageItem(storageKey);
    return;
  }
  writeToLocalStorage(storageKey, unique);
};

const addFavorite = (brandKey: string, fav: Favorite | Favorite[]) => {
  const favorites: Favorite[] =
    readLocalStorage(getFavoritesStorageKey(brandKey)) || [];
  const incoming = Array.isArray(fav) ? fav : [fav];
  writeFavorites(brandKey, [...favorites, ...incoming]);
};

const isFavorite = (brandKey: string, fav: Favorite) => {
  const favorites: Favorite[] =
    readLocalStorage(getFavoritesStorageKey(brandKey)) || [];
  return favorites.includes(fav) || false;
};

const removeFavorite = (brandKey: string, fav: Favorite) => {
  const favorites: Favorite[] =
    readLocalStorage(getFavoritesStorageKey(brandKey)) || [];
  writeFavorites(
    brandKey,
    favorites.filter((favorite) => favorite !== fav)
  );
};

export { addFavorite, isFavorite, removeFavorite };
